function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import orderBy from 'lodash/orderBy';
import { isAnyDistrict } from '@myap/metadata';
import { Autosuggest } from '..';
import { apricot } from '../../profile';
import Dropdown from '../apricot/Dropdown';
import styles from '../../../sass/navigation.module.scss';
var DropdownSearch = function DropdownSearch(props) {
  var container = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var label = props.label,
    id = props.id,
    items = props.items,
    hasAlert = props.hasAlert,
    current = props.current,
    alignDropdownRight = props.alignDropdownRight;
  var _apricot$utils$keys = apricot().utils.keys,
    ENTER = _apricot$utils$keys.ENTER,
    ESC = _apricot$utils$keys.ESC;
  var parent = isAnyDistrict(current.role) ? items.find(function (i) {
    return i.orgId === current.orgId;
  }) : items.find(function (i) {
    return i.orgId === current.parentOrgId;
  });
  var processSelection = function processSelection(selection) {
    selection.action();
    setOpen(false);
    setValue(null);
  };
  var closeDropdownOnClickOut = function closeDropdownOnClickOut(e) {
    if (!container.current.contains(e.target)) setOpen(false);
  };
  var closeDropdownOnEscape = function closeDropdownOnEscape(e) {
    if (e.keyCode === ESC) setOpen(false);
  };
  useEffect(function () {
    document.addEventListener('click', closeDropdownOnClickOut);
    document.addEventListener('keydown', closeDropdownOnEscape);
    return function () {
      document.removeEventListener('click', closeDropdownOnClickOut);
      document.removeEventListener('keydown', closeDropdownOnEscape);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown ".concat(styles['org-search']),
    ref: container
  }, /*#__PURE__*/React.createElement("a", {
    id: id,
    href: "#",
    "aria-expanded": open,
    "aria-controls": "dropdown-".concat(id),
    role: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      setOpen(!open);
    }
  }, label, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Press Enter for Dropdown.")), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu ".concat(styles['org-search-dropdown'], " ").concat(alignDropdownRight ? styles['org-search-right'] : ''),
    "aria-labelledby": id,
    role: "region",
    id: "dropdown-".concat(id)
  }, /*#__PURE__*/React.createElement(Autosuggest, {
    turnOnClickOutListener: false,
    minCharacterSearchLength: 0,
    className: "".concat(styles['org-search-autosuggest'], " ").concat(hasAlert ? styles['with-alerts'] : ''),
    name: "searchOrg",
    placeholder: "Search by organization name or AI code",
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    value: value,
    renderSuggestion: function renderSuggestion(props) {
      return props.label;
    },
    selectSuggestion: processSelection,
    fetchSuggestions: function fetchSuggestions(val) {
      var suggestions = items.filter(function (child) {
        return child.searchValues.find(function (v) {
          return v && v.toLowerCase().includes(val.toLowerCase());
        });
      }).slice(0, 10);
      return {
        suggestions: suggestions,
        total: suggestions.length
      };
    },
    footer: parent ? {
      component: function component(props) {
        return /*#__PURE__*/React.createElement("button", _extends({}, props, {
          type: "button",
          className: styles['org-search-return-btn'],
          onClick: function onClick() {
            return processSelection(parent);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.keyCode === ENTER) processSelection(parent);else if (props.onKeyDown) props.onKeyDown(e);
          }
        }), /*#__PURE__*/React.createElement("span", null, "Return to ", parent.label));
      },
      alwaysVisible: true
    } : null
  })));
};
var DropdownOrgLabel = function DropdownOrgLabel(_ref) {
  var orgName = _ref.orgName,
    role = _ref.role,
    notAbleToOrder = _ref.notAbleToOrder,
    aiCode = _ref.aiCode,
    orgId = _ref.orgId,
    _ref$showCode = _ref.showCode,
    showCode = _ref$showCode === void 0 ? false : _ref$showCode;
  return /*#__PURE__*/React.createElement(React.Fragment, null, notAbleToOrder ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "cb-glyph cb-exclamation ".concat(styles['org-alert']),
    id: "org-dropdown-".concat(orgId),
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Alert: Participation form needs to be signed")) : null, /*#__PURE__*/React.createElement("span", {
    className: isAnyDistrict(role) ? styles['org-parent'] : ''
  }, orgName, showCode && aiCode ? " (".concat(aiCode, ")") : ''));
};

/* options:
- selectedOrgId
- roles: [{ orgId, notAbleToOrder, role, aiCode, parentOrgId, parentOrgName }] // include parentOrgId only if it is a district admin
- action
- minSearchLength: minimum number of roles needed before org dropdown switches to search dropdown
*/
export default (function (_ref2) {
  var selectedOrgId = _ref2.selectedOrgId,
    roles = _ref2.roles,
    _action = _ref2.action,
    _ref2$minSearchLength = _ref2.minSearchLength,
    minSearchLength = _ref2$minSearchLength === void 0 ? 10 : _ref2$minSearchLength,
    alignDropdownRight = _ref2.alignDropdownRight;
  var current = roles.find(function (r) {
    return r.orgId === selectedOrgId;
  }) || roles[0];
  var hasAlert = roles.find(function (r) {
    return r.notAbleToOrder;
  });
  var isSearchDropdown = roles.length > minSearchLength;
  var items = roles.map(function (r) {
    return {
      label: DropdownOrgLabel(_objectSpread(_objectSpread({}, r), {}, {
        showCode: isSearchDropdown
      })),
      action: function action() {
        return _action(r);
      },
      isParent: isAnyDistrict(r.role),
      searchValues: [r.orgName, r.aiCode],
      orgId: r.orgId
    };
  });
  var alphabeticalItems = orderBy(items, [function (item) {
    return item.searchValues[0];
  }], ['asc']);
  var options = isSearchDropdown ? {
    hasAlert: hasAlert
  } : {
    className: "".concat(styles['org-dropdown'], " ").concat(hasAlert ? styles['dropdown-with-alert'] : ''),
    useApricotDropdown: false,
    triggerDisplaysAsCurrentSelection: true
  };
  var Component = isSearchDropdown ? DropdownSearch : Dropdown;
  return /*#__PURE__*/React.createElement(Component, _extends({
    id: "orgToggleDropdown",
    label: DropdownOrgLabel(current),
    items: alphabeticalItems,
    current: current,
    alignDropdownRight: alignDropdownRight
  }, options));
});